<template>
	<div v-on:mouseenter="mouseEnter" style="display: inline-block;">
		<div class="flex customer-link">
			<a class="customer-link-link" :href="'/#/customer/' + id()">{{ displayName }}</a>

			<div class="customer-link-button">
				<SvgIcon name="settings" v-on:click="$refs.dropdown.toggle()" />
				<CustomerDropdown v-if="dropDownCreated" ref="dropdown" :id="id()" />
			</div>
		</div>
	</div>
</template>

<script>
import CustomerDropdown from './CustomerDropdown.vue'

export default {
  props: [
    'customer'
  ],
  data: () => ({
  	dropDownCreated: false
  }),
  components: {
    CustomerDropdown
  },
  computed: {
  	displayName () {
  		if (this.customer.display_name) {
  			return this.customer.display_name
  		}

  		if (this.customer.full_name) {
  			return this.customer.full_name
  		}

  		return this.customer.first_name + (this.customer.last_name ? ' ' + this.customer.last_name : '')
  	}
  },
  methods: {
  	mouseEnter () {
  		if (this.dropDownCreated) {
  			return
  		}
  		this.dropDownCreated = true
  	},
    id () {
      return this.customer.id ? this.customer.id : this.customer.ID
    }
  }
}
</script>

<style type="text/css" lang="less">
	.customer-link {
		.customer-link-link {
			margin-right: 2px;
		}
		.customer-link-button {
			margin-left: 4px;
			> .svg-icon svg {
				width: 18px !important;
				height: 18px !important;
				fill: #555;
				cursor: pointer;
			}
			&:hover {
				> .svg-icon svg {
					fill: #222;
				}
			}
		}
	}
</style>
